import { reactive, defineComponent, watch, computed } from "vue";
import { ArrowDown } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
import { analyzeRoutePath, toRouteByCode } from "@/hooks/route";
import store from "@/store";
import { request } from "@/axios";
import ContactUs from "./content/ContactUs.vue";
export default defineComponent({
  name: "PageHeader",
  components: {
    ArrowDown,
    ContactUs
  },
  emits: ["serviceChange"],
  props: {
    services: {
      type: Array,
      default: () => []
    },
    service: {
      type: String,
      default: ""
    }
  },
  setup(props, ctx) {
    const router = useRouter();
    const state = reactive({
      activeIndex: "2",
      service: "",
      isIsv: false,
      showTooltip: false
    });
    const identity = computed(() => store.state.userInfo?.identityType);
    const userName = computed(() => store.state.userInfo?.pin);
    watch(() => props.service, val => {
      state.service = val;
    }, {
      immediate: true
    });
    watch(() => router.currentRoute.value.meta.activeName, activeName => {
      if (activeName) {
        state.activeIndex = analyzeRoutePath(activeName);
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => store.state.userInfo.identityType, newIdentityType => {
      state.isIsv = newIdentityType === "1";
    }, {
      immediate: true
    });
    watch(() => store.state.userInfo.stockUser, newValue => {
      state.showTooltip = newValue === "1";
    }, {
      immediate: true
    });
    const onSelect = val => {
      // state.activeIndex = val;
      toRouteByCode(val);
    };
    const onSelectService = appkey => {
      const currentService = props.services.find(item => {
        return item.value === appkey;
      });
      const data = {
        identityType: "0",
        appkey: appkey
      };
      request.userIdentitySwitch({
        data: data
      }).then(() => {
        ctx.emit("serviceChange", appkey, currentService?.label);
      });
    };
    const onChangeIdentity = () => {
      store.commit("setIdentityDialogVisible", true);
      window.log("manage-my", "switch", "{}");
    };
    const onDoc = () => {
      window.log("manage-my", "help", "{}");
      window.open("https://cloud.jdl.com/#/open-business-document/access-guide/157/54842", "_blank");
    };
    const onLoginOut = async () => {
      // location.replace(
      //   "https://passport.jd.com/uc/login?ltype=logout&ReturnUrl=" +
      //     encodeURIComponent(location.origin)
      // );
      try {
        window.log("manage-my", "logout", "{}");
        // await jsonp("https://sso.jdl.com/exit");
        // await jsonp("https://sso.jd.com/exit");
        try {
          const response = await request.nodeServeToken();
          await request.nodeServeLogout({
            headers: {
              "x-token": response.data
            }
          });
        } catch (error) {
          console.log("node未登录", error);
        }
        window.location.href = process.env.VUE_APP_LOGOUT + encodeURIComponent(location.origin);
        // window.location.href = location.origin;
      } catch (err) {
        console.log("退出登录出错：", err);
      }
    };
    const onCommand = command => {
      console.log("command", command);
      switch (command) {
        case "handbook":
          onDoc();
          break;
        case "logout":
          onLoginOut();
          break;
        default:
          break;
      }
    };
    const handleOpenGuide = () => {
      store.commit("setGuideDialogVisible", true);
    };
    return {
      state,
      props,
      onSelect,
      onSelectService,
      onCommand,
      identity,
      userName,
      handleOpenGuide,
      onChangeIdentity
    };
  }
});